import React from 'react';
import MultiAutoCompleteFilter from 'components/list/Filters/types/MultiAutoCompleteFilter';

const MultiProductIdFilter = (props) => {
    return (
        <MultiAutoCompleteFilter
            label='filters.components.providerId.label'
            options={ {
                fullWidth: true,
            } }
            searchParams={ {
                size: '12',
                sort_by: 'title',
                sort_direction: 'asc',
            } }
            reference='products'
            optionValue='id'
            searchBy='title'
            source='product_id'
            { ...props }
        />
    );
};

export default MultiProductIdFilter;



// WEBPACK FOOTER //
// ./src/components/form/filters/MultiProductFilter.js